const { REACT_APP_API_URL } = process.env;

const getQrCardImage = (code: string, locale = "es") => {
  return `${REACT_APP_API_URL}/qr/${code}?locale=${locale}`;
};

export default getQrCardImage;
